<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter"><img src="@/assets/img/appointment/back.svg" /></div>
      <div class="nav-title d-allcenter overflow"></div>
      <div class="nav-right"></div>
    </div>
    <div class="content">
      <div class="each d-between d-aligncnter">
        <div>人脸</div>
        <div class="photo"><img src="@/assets/img/appointment/demo.png" /></div>
      </div>
      <div class="each d-between d-aligncnter">
        <div>姓名</div>
        <div class="grey">张三</div>
      </div>
      <div class="each d-between d-aligncnter">
        <div>手机号</div>
        <div><el-input v-model="phone" placeholder="请输入手机号"></el-input></div>
      </div>
    </div>
    <div class="d-allcenter">
      <button class="save-btn">保&nbsp;&nbsp;&nbsp;&nbsp;存</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      phone: '',
    }
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}
.content {
  padding: 0;
}
.each {
  background: #f9f9f9;
  box-shadow: 0px -1px 0px 0px #e8e8e8 inset;
  padding: 8px 16px;
  min-height: 32px;
  color: #181818;
}
.photo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d4a3fc;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.save-btn {
  border-radius: 52px;
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  width: 343px;
  height: 56px;
  border: none;
  color: #fff;
  font-size: 18px;
  position: fixed;
  bottom: 52px;
}
</style>
